<template>
  <div>
    <CCard
      title="Plan Organization"
    >
      <CCardHeader>
        <CRow>
          <CCol col=4>
            <CIcon size="2xl" name="cil-grid"/> Plan Organization
          </CCol>
          <CCol col=8 class="align-right">
            <CButtonToolbar>
              <input 
                class="search" 
                type="search"
                v-model="findKeyword"
                v-on:input="handleKeyword"
                placeholder="โครงการ, ปีงบประมาณ, ความเป็นเจ้าของ, ชนิด"
              >
            </CButtonToolbar>
          </CCol>
        </CRow>

      </CCardHeader>
      <CCardBody>
        <CDataTable
          :hover="false"
          :striped="true"
          :border="true"
          :small="false"
          :fixed="false"
          :items-per-page="20"
          :dark="false"
          pagination
          :items="plansTable"
          :fields="plansTableFields"
        >
        </CDataTable>
      </CCardBody>
    </CCard>

    <Snackbar :isActivated="isAlert" :message="alertMessage" :color="alertColor"></Snackbar>

  </div>
</template>

<script>
import config  from '@/config'
import { axiosInstance } from '@/api'
// import { range, parseQueryString, parseBoolString, stringToHex } from '@/utils'

import Snackbar from '@/vue/base/Snackbar.vue'
import CCmonth from '@/vue/base/CCmonth.vue'
import CCNumber from '@/vue/base/CCNumber.vue'

import '@/assets/scss/search_box.scss'


import Ajv from "ajv"
import { TRUE } from 'sass'


const ajv = new Ajv()

export default {
  name: 'Plan',
  components: { Snackbar, CCmonth, CCNumber },
  data () {
    return {
      isDeletabled: false,
      isManageInfo: false,
      isManagePlan: false,
      isCreateOrEditPlan: false,
      isAlert: false,
      alertCountDown: 0,
      alertColor: 'info',
      alertMessage: '',
      findKeyword: '',
      feedback: {},
      
      // PlanSchema: {},
      // plan: {},
      plans: [],
      // selectedPlan: {},
      plansTableFields:  [
        { key: 'project', label: 'ชื่อโครงการ' },
        { key: 'project_year', label: 'ปีงบประมาณ' },
        // { key: 'delivered_month', label: 'เดือนที่คาดว่าจะได้รับยานพาหนะ' },
        { key: 'ev_type', label: 'ชนิดรถไฟฟ้า' },
        { key: 'usage_type', label: 'รูปแบบการใช้งาน' },
        // { key: 'battery_size', label: 'ขนาดแบตเตอรี่ (kWh)' },
        // { key: 'amount', label: 'จำนวนรถ (คัน)' },
        { key: 'ownership', label: 'ลักษณะความเป็นเจ้าของ' },
        { key: 'state', label: 'สถานะโครงการ' },
        { key: 'email', label: 'ผู้กรอกข้อมูล' }
      ],
      selectEVTypeOption: ["ev","hev","phev"],
      selectUsageTypeOption: [
        {
          value: 'car',
          label: 'นั่งส่วนบุคคล'
        },
        {
          value: 'bus',
          label: 'โดยสาร'
        },
        {
          value: 'truck',
          label: 'ขนส่งสินค้า'
        },
      ],
      selectOwnershipOption: [
        { 
          value: 'own', 
          label: 'รถซื้อ'
        },
        { 
          value: 'rent', 
          label: 'รถเช่า'
        },
      ],
      selectStateOption: [
        {
          value: 'progressed', 
          label: 'ดำเนินการแล้ว'
        },
        { 
          value: 'progressing', 
          label: 'กำลังดำเนินงาน'
        },
        { 
          value: 'planed', 
          label: 'วางแผนการดำเนินงาน'
        },
      ],
    }
  },
  computed: {
    plansTable () {
      let plans = []
      for(let i = 0; i < this.plans.length; i++) {
        let plan = Object.assign({},this.plans[i])
        plan['usage_type'] = this.findLabelByValue(this.selectUsageTypeOption , plan['usage_type'])
        plan['ownership'] = this.findLabelByValue(this.selectOwnershipOption, plan['ownership'])
        plan['state'] = this.findLabelByValue(this.selectStateOption, plan['state'])

        // ### move user-email to email
        plan['email'] = plan['user']['email']
        delete plan['user']
        plans.push(plan)
      }
      
      let filteredPlans = []
      for(let i = 0; i < plans.length; i++) {
        if (
          plans[i]['project'].includes(this.findKeyword)
          || plans[i]['project_year'].toString().includes(this.findKeyword)
          || plans[i]['ev_type'].includes(this.findKeyword)
          || plans[i]['usage_type'].includes(this.findKeyword)
          || plans[i]['ownership'].includes(this.findKeyword)
          || plans[i]['state'].includes(this.findKeyword)
          || plans[i]['email'].includes(this.findKeyword)
        ) {
          filteredPlans.push(plans[i])
        }
      }
      return filteredPlans
    },
  },
  mounted() {
    this.checkUserOrganization()
    this.getPlanOrganization()
  },
  watch: {
  },
  methods: {
    findLabelByValue(options, searchValue) {
      const foundOption = options.find(option => option.value === searchValue)
      return foundOption ? foundOption.label : ''
    },
    handleKeyword () {
      // Nothing to do, the keyword is used in computed()
    },
    checkUserOrganization () {
      axiosInstance({
        method: 'get',
        url: '/user/getOrCreate',
      })
      .then(response => {
        if(response.status === 200 || response.status === 201) {
          // console.log('/user/getOrCreate response-data: '+JSON.stringify(response.data, null, 2))
          this.user = response.data
          // if (typeof this.user.organizationId === 'number') {
          //   this.getOrganizationOfyourself()
          // } else {
          if (!this.user.organizationId) {
            this.alertColor = 'danger'
            this.alertMessage = 'Please update your organization'
            this.isAlert = !this.isAlert
          }
        } 
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    getPlanOrganization () {
      axiosInstance({
        method: 'get',
        url: '/plan/organization'
      })
      .then(response => {
        // console.log(`get Plan: ${JSON.stringify(response.data, null, 2)}`)
        if(response.status === 200) {
          this.plans = response.data
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },

  }
}
</script>

<style scoped lang="scss">
  // .table-header {
  //   font-size: 1rem;
  //   margin-bottom: -15px;
  // }

  /* Center align content in the first column */
  .align-center {
    // text-align: center;
    display: flex;
    align-items: center; /* Vertical alignment */
    justify-content: center; /* Horizontal alignment */
  }

  /* Right align content in the second column */
  .align-right {
    display: flex;
    align-items: right; /* Vertical alignment */
    justify-content: right; /* Horizontal alignment */
  }
</style>